module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "CT"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_vm._v("xiii")])]), _vm._v(" "), _c('p', {
    staticClass: "_pract",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v(" Practices")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-ct"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v("Chapter 1")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-practices ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SpiritsUnveiled1#_idTextAnchor009"
    }
  }, [_vm._v("Identifying Spirits Through  11 Solfeggio Frequencies")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-practices ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SpiritsUnveiled1#_idTextAnchor010"
    }
  }, [_vm._v("Using Clairs to Connect")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-practices ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SpiritsUnveiled1#_idTextAnchor011"
    }
  }, [_vm._v("11 Steps to Broaden Your Frequency Bandwidth")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-practices ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SpiritsUnveiled1#_idTextAnchor012"
    }
  }, [_vm._v("11 Spirit Guide Red Flags")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-ct"
  }, [_vm._v("Chapter 2")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-practices ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SpiritsUnveiled2#_idTextAnchor015"
    }
  }, [_vm._v("11 Steps for Connecting  with an Ascended Master")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-ct"
  }, [_vm._v("Chapter 3")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-practices ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SpiritsUnveiled3#_idTextAnchor018"
    }
  }, [_vm._v("Which Archangel Is Working with You Now?")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-practices ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SpiritsUnveiled3#_idTextAnchor019"
    }
  }, [_vm._v("11 Steps for Connecting with an Archangel")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-ct"
  }, [_vm._v("Chapter 4")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-practices ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SpiritsUnveiled4#_idTextAnchor022"
    }
  }, [_vm._v("11 Ways to Know Your Loved One Is with You")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-practices ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SpiritsUnveiled4#_idTextAnchor023"
    }
  }, [_vm._v("11 Steps to Match Frequencies in the Future")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-ct"
  }, [_vm._v("Chapter 5")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-practices ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SpiritsUnveiled5#_idTextAnchor026"
    }
  }, [_vm._v("11 Ways to Recognize  Animal Guides in Your Life")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-practices ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SpiritsUnveiled5#_idTextAnchor027"
    }
  }, [_vm._v("Groupings of Animal Guides  According to Ways They Can Help You")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-ct"
  }, [_vm._v("Chapter 6")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-practices ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SpiritsUnveiled6#_idTextAnchor030"
    }
  }, [_vm._v("11 Ways to Scry to Connect with Elementals")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-practices ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SpiritsUnveiled6#_idTextAnchor031"
    }
  }, [_vm._v("11 Ways to Connect with  Elementals Using the Elements")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-practices ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SpiritsUnveiled6#_idTextAnchor032"
    }
  }, [_vm._v("11 Steps to Tea Scrying  (Tasseography or Tasseomancy)")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-practices ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SpiritsUnveiled6#_idTextAnchor033"
    }
  }, [_vm._v("11 Ways to Collaborate with Elementals")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-ct"
  }, [_vm._v("Chapter 7")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-practices ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SpiritsUnveiled7#_idTextAnchor036"
    }
  }, [_vm._v("11 Things to Look for  Regarding Spirit Visitations")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-practices ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SpiritsUnveiled7#_idTextAnchor037"
    }
  }, [_vm._v("11 Ways to Know a Ghost is Near")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-ct"
  }, [_vm._v("Chapter 8")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-practices ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SpiritsUnveiled8#_idTextAnchor040"
    }
  }, [_vm._v("11 Ways to Identify the  Spirit of the Land, Place, or Thing")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-practices ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SpiritsUnveiled8#_idTextAnchor041"
    }
  }, [_vm._v("11 Signs of the Use of  Clairtangency (Psychometry)")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-ct"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_vm._v("xiv")]), _vm._v("Chapter 9")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-practices ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SpiritsUnveiled9#_idTextAnchor044"
    }
  }, [_vm._v("11 Steps to Create a Thought Form")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-practices ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SpiritsUnveiled9#_idTextAnchor045"
    }
  }, [_vm._v("11 Ways to Protect Against Psychic Attack")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-ct"
  }, [_vm._v("Chapter 10")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-practices ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SpiritsUnveiled10#_idTextAnchor048"
    }
  }, [_vm._v("Which Starseed Are You?")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-practices ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SpiritsUnveiled10#_idTextAnchor049"
    }
  }, [_vm._v("11 Steps for Automatic Writing  to Connect with Your Galactic Guides")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-practices ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SpiritsUnveiled10#_idTextAnchor050"
    }
  }, [_vm._v("11 Ways Multidimensionals Can Help You")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-ct"
  }, [_vm._v("Chapter 11")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-practices ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SpiritsUnveiled11#_idTextAnchor053"
    }
  }, [_vm._v("11 Steps to Astral Travel")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3707eca4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pract.vue
// module id = 72
// module chunks = 0